
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"40","height":"40","rx":"3.193","fill":"#fff"}}),_c('path',{attrs:{"d":"M12.619 25.5a1.5 1.5 0 001.5 1.5h11a1.5 1.5 0 001.5-1.5V17h-14v8.5zm4-6.125c0-.206.169-.375.375-.375h5.25c.206 0 .375.169.375.375v.25a.376.376 0 01-.375.375h-5.25a.376.376 0 01-.375-.375v-.25zm10-6.375h-14a1 1 0 00-1 1v1.5c0 .275.225.5.5.5h15c.275 0 .5-.225.5-.5V14a1 1 0 00-1-1z","fill":"#000","fill-opacity":".38"}})])
          )
        }
      }
    